import React from 'react';

function DebugDisplay ({ config, selectedDate, imageUrl, loaded, showAlert }) {

  const { apiAuthKey, ...configWithoutAuthKey } = config;
  
  return (
    <div className="debugDisplay">
      <pre>Debug</pre>
      <pre>{JSON.stringify(configWithoutAuthKey, null, 2)} <br />selectedDate: {selectedDate}<br />imageUrl: {imageUrl}<br />
      loaded: {loaded}<br />showAlert: {showAlert}</pre>
    </div>
  );
};

export default DebugDisplay;
